module.exports = __webpack_public_path__ + "static/media/bannerimg02.bbed8fae.jpg";